// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"28d6ca7c","250":"ac1aeaa1","787":"ac2e75b7"}[chunkId] + ".chunk.js";
};